import React from 'react'
import AusbildungsplanContent from '#components/m/Ausbildungsplan/AusbildungsplanContent'
import {useAusbildungsplan} from '#hooks/useAusbildungsplan'
import {useParams} from 'react-router-dom'

export function AusbildungsplanContainer() {
  const params = useParams()
  const azubiId = parseInt(params.azubiId, 10)
  const {findDeep, ready, getFullContent} = useAusbildungsplan(azubiId)
  let content = getFullContent()
  if (ready && params && params.chapterId) {
    const chapter = findDeep(params.chapterId)
    if (chapter) {
      content = chapter.content
    }
  }

  return (
    <div className="ausbildungsplan">
      {content.map((item, index) => (
        <AusbildungsplanContent element={item} key={index.toString()} azubiId={azubiId} />
      ))}
    </div>
  )
}

AusbildungsplanContainer.propTypes = {}

export default AusbildungsplanContainer
